import { URL_CONFIG } from "./urlConfig";

export const API_URL = {
  SAVE_FORM_DATA: `${URL_CONFIG.API_BASE_URL}/Corvell/api/form-data.php`,
  SAVE_EXTENDED_WARRANTY: `${URL_CONFIG.API_BASE_URL}/Corvell/api/form-warranty.php`,
  GET_DASHBOARD_DATA: `${URL_CONFIG.API_BASE_URL}/Corvell/api/tableData.php`,
};

export const STATIC_APIS = {
  FETCH_PINCODE_DETAILS: (pincode) =>
    `https://api.postalpincode.in/pincode/${pincode}`,
};
